export default __webpack_public_path__ + "static/media/kolkhoz.38b9fe19.jpeg";